/**
 * @file: ServiceSubjectsCatalog.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The reusable catalog body (the tabbed list + search overlay + the custom /
 * selected-subjects sheets). It reads everything through `useServiceSubjectsHost`,
 * so both the order screen and the reservation picker mount it under their own
 * host provider + header.
 */

import { memo } from 'react';
import { ServiceSubjectsContent } from './ServiceSubjectsContent';
import { ServiceSubjectsContextProvider } from './ServiceSubjectsContext';

export const ServiceSubjectsCatalog = memo(() => (
  <ServiceSubjectsContextProvider>
    <ServiceSubjectsContent />
  </ServiceSubjectsContextProvider>
));
